<template>
  <loading v-if="loading"></loading>
  <div class="contain" v-else>
    <div class="contain-top">
      <img :src="details.cover" alt="" />
      <div class="contain-top-right">
        <!-- 比赛信息 -->
        <div class="contain-top-right-match">
          <div class="contain-top-right-match-left">
            <img :src="details.logo" alt="" />
            <div class="contain-top-right-match-left-box">
              <div class="contain-top-right-match-left-box-title">
                {{ details.name }}
              </div>
              <div class="contain-top-right-match-left-box-time">
                <!-- <div>{{details.enroll_num}}人已报名</div> -->
                <!-- <div>2.3km</div> -->
              </div>
            </div>
          </div>
          <el-button
            :type="
              details.status == 1
                ? 'info'
                : details.status == 2
                ? 'primary'
                : details.status == 3
                ? 'danger'
                : details.status == 4
                ? 'primary'
                : details.status == 5
                ? 'danger'
                : ''
            "
            >{{
              details.status == 1
                ? "未开始"
                : details.status == 2
                ? "报名中"
                : details.status == 3
                ? "报名结束"
                : details.status == 4
                ? "进行中"
                : details.status == 5
                ? "已结束"
                : ""
            }}</el-button
          >
        </div>
        <!-- 比赛时间地址和奖励 -->
        <div class="contain-top-right-item">
          <div class="contain-top-right-item-box">
            <img src="../../assets/image/matchDate.png" alt="" />
            <span>{{ details.start_at }} 开赛</span>
          </div>
          <div class="contain-top-right-item-box">
            <img src="../../assets/image/ren.png" alt="" />
            <span>{{ details.enroll_num }}人报名</span>
          </div>
          <div class="contain-top-right-item-box2" @click="goRewardDetails">
            <img src="../../assets/image/reward.png" alt="" />
            <span>奖励详情</span>
          </div>
          <div
            class="match-box-item-operation-btn"
            :style="{
              background:
                details.is_enroll == 1 ||
                details.status == 1 ||
                details.status == 3 ||
                details.status == 4
                  ? '#B4B4B4'
                  : details.status == 5
                  ? '#F24342'
                  : '',
            }"
            @click.stop="enroll(details.id, details.status)"
          >
            <span>{{
              details.status == 1
                ? "未开始"
                : details.status == 2 && details.is_enroll == 1
                ? "已报名"
                : details.status == 2
                ? "立即报名"
                : details.status == 3
                ? "报名结束"
                : details.status == 4
                ? "进行中"
                : details.status == 5
                ? "已结束"
                : ""
            }}</span>
          </div>
        </div>
        <!-- 比赛详细信息 -->
        <div class="contain-top-right-details">
          <div class="contain-top-right-details-box">
            <img src="../../assets/image/company.png" alt="" />
            <div>举办单位：{{ details.school.name }}</div>
          </div>
          <div class="contain-top-right-details-box">
            <img src="../../assets/image/signUpTime.png" alt="" />
            <div>
              报名时间：{{ details.enroll_start_at }} 至
              {{ details.enroll_end_at }}
            </div>
          </div>
          <div class="contain-top-right-details-box">
            <img src="../../assets/image/matchDate.png" alt="" />
            <div>赛事时间：{{ details.start_at }} 至 {{ details.end_at }}</div>
          </div>
          <div class="contain-top-right-details-box">
            <img src="../../assets/image/matchAddress.png" alt="" />
            <div>举办地点：{{ details.venue }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 比赛赛程和排行榜 -->
    <div class="contain-content">
      <!-- 比赛赛程 -->
      <div class="contain-content-left">
        <div
          class="contain-content-left-box"
          v-for="(item, index) in details.match_system"
          :key="index"
        >
          <div class="contain-content-left-box-title">
            赛程安排-{{ item.name }}
          </div>
          <div class="contain-content-left-box-item">
            <!-- 比赛时间 -->
            <div class="contain-content-left-box-item-time">
              <img src="../../assets/image/matchDate.png" alt="" />
              <span>{{ $moment(item.start_at).format("YYYY-MM-DD") }}</span>&nbsp;至
              <span>{{ $moment(item.end_at).format("YYYY-MM-DD") }}</span>&nbsp;结束
            </div>
            <!-- 比赛赛程 -->
            <div
              class="contain-content-left-box-item-big"
              v-if="item.match_arrangement.length > 0"
            >
              <!-- 战队logo -->
              <div
                class="contain-content-left-box-item-big-box"
                v-for="(item2, index2) in item.match_arrangement"
                :key="index2"
              >
                <div class="contain-content-left-box-item-big-box-date">
                  <img src="../../assets/image/matchDate.png" alt="" />
                  {{ $moment(item2.match_at).format("YYYY-MM-DD") }}
                </div>
                <div class="contain-content-left-box-item-big-logo">
                  <!-- 左边队伍 -->
                  <div class="contain-content-left-box-item-big-box-img">
                    <img
                      :src="JSON.parse(item2.team_a.team_snap).avatar"
                      alt=""
                    />
                    <img
                      v-if="item2.team_a.id == item2.win_team_id"
                      src="../../assets/image/win.png"
                      alt=""
                    />
                    <div class="team-name">
                      {{ JSON.parse(item2.team_a.team_snap).name }}
                    </div>
                  </div>
                  <!-- 中间vs -->
                  <div class="contain-content-left-box-item-big-box-vs">
                    <div class="winer" v-if="item2.status == 3">
                      <img src="../../assets/image/nowVS.png" alt="" />
                      <div class="team-score">
                        {{ item2.team_a_score }}-{{ item2.team_b_score }}
                      </div>
                    </div>
                    <div class="no-winer" v-else>
                      <div class="vs-time">
                        {{ $moment(item2.match_at).format("HH:mm") }}
                      </div>
                      <div
                        class="team-vs"
                        :style="{
                          background: item2.status == 2 ? '#3D7EFF' : '',
                        }"
                      >
                        {{
                          item2.status == 1
                            ? "未开始"
                            : item2.status == 2
                            ? "进行中"
                            : item2.status == 3
                            ? "已结束"
                            : ""
                        }}
                      </div>
                    </div>
                  </div>
                  <!-- 右边队伍 -->
                  <div class="contain-content-left-box-item-big-box-img">
                    <img
                      :src="JSON.parse(item2.team_b.team_snap).avatar"
                      alt=""
                    />
                    <img
                      v-if="item2.team_b.id == item2.win_team_id"
                      src="../../assets/image/win.png"
                      alt=""
                    />
                    <div class="team-name">
                      {{ JSON.parse(item2.team_b.team_snap).name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 五比赛 -->
            <div class="noMatch" v-else>当日暂无比赛</div>
          </div>
        </div>
      </div>
      <!-- 排行榜 -->
      <div class="contain-content-right">
        <div class="ranking-list" v-if="details.match_enroll.length > 0">
          <div class="ranking-list-title">排行榜</div>
          <div class="ranking-list-table">
            <!-- 表头 -->
            <div class="ranking-list-table-head">
              <div class="ranking-list-item">排名</div>
              <div class="ranking-list-team">战队</div>
              <div class="ranking-list-item">积分</div>
              <div class="ranking-list-item">净胜分</div>
            </div>
            <!-- 列表 -->
            <div
              class="ranking-list-table-list"
              v-for="(item3, index3) in details.match_enroll"
              :key="index3"
            >
              <div class="ranking-list-table-item">
                <img
                  v-if="index3 + 1 == 1"
                  src="../../assets/image/one.png"
                  alt=""
                />
                <img
                  v-else-if="index3 + 1 == 2"
                  src="../../assets/image/two.png"
                  alt=""
                />
                <img
                  v-else-if="index3 + 1 == 3"
                  src="../../assets/image/three.png"
                  alt=""
                />
                <span v-else>{{ index3 + 1 }}</span>
              </div>
              <div class="ranking-list-table-team">
                <img :src="JSON.parse(item3.team_snap).avatar" alt="" /><span>{{
                  JSON.parse(item3.team_snap).name
                }}</span>
              </div>
              <div class="ranking-list-table-item">{{ item3.points }}</div>
              <div class="ranking-list-table-item">{{ item3.net_points }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 奖励详情 -->
    <el-dialog
      custom-class="dialog"
      :visible.sync="dialogVisible"
      width="22%"
      :show-close="false"
    >
      <div class="reward">
        <!-- 奖励标题 -->
        <div class="reward-title">
          <img src="../../assets/image/reward.png" alt="" />
          <span>奖励详情</span>
        </div>
        <!-- 奖励内容 -->
        <div class="reward-content">
          <div
            class="reward-content-box"
            v-for="(item, index) in details.rewards"
            :key="index"
          >
            <div>{{ item.ranking }}：</div>
            <div>{{ item.award }}</div>
          </div>
        </div>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      custom-class="dialog"
      :visible.sync="code"
      width="15%"
      center
    >
      <span>请先创建该赛事类型的战队</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="code = false">取 消</el-button>
        <el-button type="primary" @click="goCreateTeam">前往</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request";
import loading from "@/components/loading/loading.vue";
export default {
  components: { loading },
  data() {
    return {
      dialogVisible: false,
      loading: true,
      details: null,
      code: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    goCreateTeam() {
      this.$router.push("/mine/my_match/my_team");
    },
    // 比赛报名
    enroll(id, status) {
      if (status != 2) {
        return;
      }
      this.code = false;
      request({
        url: "/api/userend/match/enroll",
        method: "post",
        params: { match_id: id },
      })
        .then((response) => {
          this.$message.success("报名成功");
        })
        .catch((err) => {
          if (err == "请先创建该赛事类型的战队") {
            this.code = true;
          }
        });
    },
    // 比赛详情
    getList() {
      this.loading = true;
      request({
        url: "/api/userend/match/detail",
        method: "get",
        params: { id: this.$route.query.id },
      })
        .then((response) => {
          this.details = response.data;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err, "============");
          this.$router.go(-1);
        });
    },
    goRewardDetails() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss">
.dialog {
  border-radius: 20px;
}
.reward {
  padding: 20px;
  .reward-title {
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    img {
      width: 25px;
      height: 25px;
    }
    span {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #c65e00;
      margin-left: 8px;
    }
  }
  .reward-content {
    padding: 0 15px 18px 15px;
    border-radius: 12px;
    border: 1px solid #f9fafd;
    .reward-content-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-top: 20px;
      div {
        &:nth-child(1) {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1e2134;
          line-height: 22px;
          white-space: nowrap;
        }
        &:nth-child(2) {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1e2134;
          line-height: 22px;
        }
      }
    }
  }
  .el-button {
    margin-top: 30px;
    width: 100%;
    height: 50px;
    background: #3d7eff;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
}
.contain-top {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  img {
    width: 45%;
    height: 335px;
    border-radius: 8px;
  }
  .contain-top-right {
    padding: 15px 0;
    width: 54%;
    .contain-top-right-match {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .contain-top-right-match-left {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        img {
          width: 94px;
          height: 65px;
        }
        .contain-top-right-match-left-box {
          margin-left: 15px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .contain-top-right-match-left-box-title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1e2134;
          }
          .contain-top-right-match-left-box-time {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            div {
              &:nth-child(1) {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3d7eff;
              }
              &:nth-child(2) {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #506176;
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
    .contain-top-right-item {
      margin-top: 32px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .contain-top-right-item-box {
        cursor: pointer;
        width: 22%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 46px;
        border-radius: 4px;
        border: 1px solid #f9fafd;
        img {
          width: 20px;
          height: 20px;
        }
        span {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #506176;
          margin-left: 5px;
        }
      }
      .contain-top-right-item-box2 {
        cursor: pointer;
        width: 22%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 46px;
        border-radius: 4px;
        background: #f9fafd;
        img {
          width: 20px;
          height: 20px;
        }
        span {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #506176;
          margin-left: 5px;
        }
      }
      .match-box-item-operation-btn {
        cursor: pointer;
        width: 22%;
        text-align: center;
        height: 46px;
        background: #3d7eff;
        border-radius: 6px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 46px;
      }
    }
    .contain-top-right-details {
      margin-top: 20px;
      .contain-top-right-details-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 20px;
        img {
          width: 18px;
          height: 18px;
        }
        div {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #506176;
          margin-left: 12px;
        }
      }
    }
  }
}
.contain-content {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .contain-content-left {
    width: 70%;
    .contain-content-left-box {
      padding: 20px;
      background: #ffffff;
      border-radius: 8px;
      margin-bottom: 20px;
      .contain-content-left-box-title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1e2134;
        margin-bottom: 20px;
      }
      .contain-content-left-box-item {
        margin-top: 20px;
        .contain-content-left-box-item-time {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          color: #506176;
          img {
            width: 20px;
            height: 20px;
          }
          span {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #506176;
            margin-left: 10px;
          }
        }
        .noMatch {
          padding: 20px 0;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #858585;
          text-align: center;
        }
        .contain-content-left-box-item-big {
          // padding: 20px;
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          .contain-content-left-box-item-big-box {
            padding: 21px 0px;
            margin-top: 30px;
            width: 46%;
            border-radius: 8px;
            border: 1px solid #f9fafd;
            .contain-content-left-box-item-big-box-date {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-bottom: 10px;
              color: #506176;
              img {
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }
            }
            .contain-content-left-box-item-big-logo {
              width: 100%;
              display: flex;
              flex-direction: row;
              // flex-wrap: wrap;
              justify-content: space-around;
              align-items: center;
              .contain-content-left-box-item-big-box-img {
                position: relative;
                img {
                  &:nth-child(1) {
                    width: 85px;
                    height: 85px;
                    border-radius: 50%;
                  }
                  &:nth-child(2) {
                    width: 55px;
                    height: 55px;
                    position: absolute;
                    top: -8px;
                    left: -18px;
                  }
                }
                .team-name {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #1e2134;
                  text-align: center;
                  margin-top: 20px;
                }
              }
              .contain-content-left-box-item-big-box-vs {
                margin-top: 30px;
                .winer {
                  img {
                    width: 48px;
                    height: 37px;
                    margin-bottom: 30px;
                  }
                  .team-score {
                    width: 50px;
                    height: 26px;
                    background: #f24342;
                    border-radius: 4px;
                    font-size: 14px;
                    font-family: SFProDisplay-Semibold, SFProDisplay;
                    font-weight: 600;
                    color: #ffffff;
                    line-height: 26px;
                    text-align: center;
                  }
                }
                .no-winer {
                  .vs-time {
                    font-size: 28px;
                    font-family: SFProDisplay-Bold, SFProDisplay;
                    font-weight: bold;
                    color: #506176;
                    margin-bottom: 30px;
                  }
                  .team-vs {
                    text-align: center;
                    padding: 0 15px;
                    margin: auto;
                    height: 30px;
                    background: #cccccc;
                    border-radius: 4px;
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 30px;
                    margin-top: 50px;
                  }
                }
              }
            }
          }
          // .contain-content-left-box-item-big-name{
          //     display: flex;
          //     flex-direction: row;
          //     justify-content: space-between;
          //     align-items: center;
          //     margin-top: 10px;
          //     .team-name{
          //         font-size: 14px;
          //         font-family: PingFangSC-Regular, PingFang SC;
          //         font-weight: 400;
          //         color: #1E2134;
          //     }
          //     .team-vs{
          //         text-align: center;
          //         width: 50px;
          //         height: 25px;
          //         background: #CCCCCC;
          //         border-radius: 4px;
          //         font-size: 12px;
          //         font-family: PingFangSC-Regular, PingFang SC;
          //         font-weight: 400;
          //         color: #FFFFFF;
          //         line-height: 25px;
          //     }
          // }
        }
      }
    }
  }
  .contain-content-right {
    width: 25%;
    .ranking-list {
      padding: 20px;
      background: #ffffff;
      border-radius: 8px;
      .ranking-list-title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1e2134;
      }
      .ranking-list-table {
        margin-top: 15px;
        .ranking-list-table-head {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 10px 0;
          background: #f9fafd;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #858585;
          .ranking-list-item {
            width: 22%;
            text-align: center;
          }
          .ranking-list-team {
            width: 34%;
            text-align: center;
          }
        }
        .ranking-list-table-list {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding: 15px 0;
          border-bottom: 1px solid #f9fafd;
          .ranking-list-table-item {
            width: 22%;
            text-align: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
            img {
              width: 25px;
              height: 25px;
            }
          }
          .ranking-list-table-team {
            width: 34%;
            text-align: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            img {
              width: 25px;
              height: 25px;
              border-radius: 50%;
            }
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #1e2134;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
}
</style>